import React, {Component} from 'react';
import Cart from '../Cart/Cart';
import Client from 'shopify-buy';
import '../Cart/cart.scss'
import {Link} from "react-router-dom";
import Logo from "../../assets/images/hea-logo.png";
import Product from "../Cart/Product";

const client = Client.buildClient({
    storefrontAccessToken: '87204a2ca56a3c23450e69c110ef5a83',
    domain: 'marriage365.myshopify.com/'
});

class Purchase extends Component {
    constructor() {
        super();

        this.state = {
            isCartOpen: false,
            checkout: {lineItems: []},
            product: null,
            shop: {}
        };

        this.handleCartClose = this.handleCartClose.bind(this);
        this.addVariantToCart = this.addVariantToCart.bind(this);
        this.updateQuantityInCart = this.updateQuantityInCart.bind(this);
        this.removeLineItemInCart = this.removeLineItemInCart.bind(this);
    }

    componentWillMount() {
        client.checkout.create().then((res) => {
            this.setState({
                checkout: res,
            });
        });

        client.product.fetch('Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0LzM4ODAyMjk2OTk2MDc=').then((res) => {
            this.setState({
                product: res,
            });
            // console.log(res)
        });

        client.shop.fetchInfo().then((res) => {
            this.setState({
                shop: res,
            });
        });
    }

    addVariantToCart(variantId, quantity) {
        this.setState({
            isCartOpen: true,
        });

        const lineItemsToAdd = [{variantId, quantity: parseInt(quantity, 10)}]
        const checkoutId = this.state.checkout.id

        return client.checkout.addLineItems(checkoutId, lineItemsToAdd).then(res => {
            this.setState({
                checkout: res,
            });
        });
    }

    updateQuantityInCart(lineItemId, quantity) {
        const checkoutId = this.state.checkout.id
        const lineItemsToUpdate = [{id: lineItemId, quantity: parseInt(quantity, 10)}]

        return client.checkout.updateLineItems(checkoutId, lineItemsToUpdate).then(res => {
            this.setState({
                checkout: res,
            });
        });
    }

    removeLineItemInCart(lineItemId) {
        const checkoutId = this.state.checkout.id

        return client.checkout.removeLineItems(checkoutId, [lineItemId]).then(res => {
            this.setState({
                checkout: res,
            });
        });
    }

    handleCartClose() {
        this.setState({
            isCartOpen: false,
        });
    }

    render() {
        return (
            <div className="purchase-container">
                <div id="nav">


                    <div className="logo">
                        <Link to="/progress/">
                            <img src={Logo}/>
                        </Link>
                    </div>
                    <div className="links-container">
                        <ul>
                            <li style={{borderRight: '1px solid #aba'}}>
                                <button className="App__view-cart">
                                    <Link to="login">Login</Link>
                                </button>
                            </li>
                            <li>
                                {!this.state.isCartOpen &&
                                <div className="App__view-cart-wrapper">
                                    <button className="App__view-cart"
                                            onClick={() => this.setState({isCartOpen: true})}>Cart
                                    </button>
                                </div>
                                }
                            </li>
                        </ul>
                    </div>

                </div>
                <header className="App__header">

                    <div className="App__title">

                    </div>
                </header>
                {
                    this.state.product &&
                    <div className="Product-wrapper">
                        <Product
                            addVariantToCart={this.addVariantToCart}
                            client={client}
                            key={this.state.product.id}
                            product={this.state.product}
                        />
                    </div>
                }


                <Cart
                    checkout={this.state.checkout}
                    isCartOpen={this.state.isCartOpen}
                    handleCartClose={this.handleCartClose}
                    updateQuantityInCart={this.updateQuantityInCart}
                    removeLineItemInCart={this.removeLineItemInCart}
                />
            </div>
        );
    }
}

export default Purchase;
